import { useCallback } from 'react'

import { useUserAccessPolicy } from '../lib/auth/user-access-policy'
import { useTestKitProducts } from '../lib/products/hooks/useTestKitProducts'

export interface UseTestKitPrice {
  shouldShowTestKitPrice: (sku: string) => boolean
}

const useTestKitPrice = (): UseTestKitPrice => {
  const { isTestKitSku } = useTestKitProducts()
  const { canPurchaseTestKits } = useUserAccessPolicy()

  const shouldShowTestKitPrice = useCallback(
    (sku: string) => {
      const isTestKit = isTestKitSku(sku)
      return !isTestKit || canPurchaseTestKits
    },
    [canPurchaseTestKits, isTestKitSku],
  )

  return {
    shouldShowTestKitPrice,
  }
}

export { useTestKitPrice }
